import React, { useEffect, useRef } from 'react'
import '../assets/css/Shapes.scss'

const FramePanel = ({ addNewCanvas, setActiveTool }) => {
    const frameRef = useRef()

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick, {
            capture: true
        })

        return () => {
            document.removeEventListener('click', handleOutsideClick, {
                capture: true
            })
        }
    }, [])

    const handleClick = (canvasName) => {
        addNewCanvas(canvasName)
    }

    const handleOutsideClick = (e) => {
        if (frameRef.current && !frameRef.current?.contains(e.target)) {
            setActiveTool('select')
        }
    }

    return (
        <div
            className='toolpanel visible framePanel all-artboards'
            ref={frameRef}
        >
            <div className='artboards'>
                <div className='artboards-row'>
                    <p onClick={() => handleClick('Flat sketches')}>
                        Flat sketches
                    </p>
                    <p onClick={() => handleClick('Colored sketch')}>
                        Colored sketch
                    </p>
                    <p onClick={() => handleClick('Style details')}>
                        Style details
                    </p>
                </div>
                <div className='artboards-row'>
                    <p onClick={() => handleClick('Font-Back looks')}>
                        Font-Back looks
                    </p>
                    <p onClick={() => handleClick('Style ref')}>Style ref</p>
                    <p onClick={() => handleClick('Annotation')}>Annotation</p>
                </div>
                <div className='artboards-row'>
                    <p onClick={() => handleClick('3D')}>3D</p>
                    <p onClick={() => handleClick('Comments on 3D')}>
                        Comments on 3D
                    </p>
                </div>
                <div className='artboards-row'>
                    <p onClick={() => handleClick('Artwork')}>Artwork</p>
                    <p onClick={() => handleClick('Artwork placement')}>
                        Artwork placement
                    </p>
                </div>
                <div className='artboards-row'>
                    <p onClick={() => handleClick('Wash ref')}>Wash ref</p>
                    <p onClick={() => handleClick('Wash details')}>
                        Wash details
                    </p>
                </div>
                <div className='artboards-row'>
                    <p onClick={() => handleClick('Measurement')}>
                        Measurement
                    </p>
                    <p onClick={() => handleClick('Fitting comments')}>
                        Fitting comments
                    </p>
                </div>
            </div>
        </div>
    )
}

export default FramePanel
